import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { AdminLayoutService } from '../admin-layout/admin-layout.service';

declare var $: any;
declare var DevExpress: any;

@Component({
  selector: 'app-blank-layout',
  templateUrl: './blank-layout.component.html',
})
export class BlankLayoutComponent implements OnInit {
  currentUser: any = {};
  constructor(
    public translate: TranslateService,
    private loader: NgxUiLoaderService,
    private service: AdminLayoutService,
    private local: LocalStoreService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // Translator init
    const currentLang = this.local.getItem('lang');
    if (currentLang)
      translate.use(
        currentLang.code.match(/en|fr|vi/) ? currentLang.code : 'vi'
      );
  }

  ngOnInit() {
    this.service.connectSignalR();
  }
}
